import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconShield1: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#F04438',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0977 2.84276C10.815 2.18609 9.677 1.61288 8.23633 0.886215C8.09566 0.816215 7.90906 0.824825 7.76839 0.895492C6.30839 1.61949 5.15438 2.19209 1.90104 2.84276C1.66704 2.88942 1.49902 3.09483 1.49902 3.33283V7.25877C1.49902 12.7481 6.78165 14.7874 7.84098 15.1408C7.89232 15.1581 7.94569 15.1668 7.99902 15.1668C8.05236 15.1668 8.10573 15.1581 8.15706 15.1408C9.2164 14.7874 14.499 12.7481 14.499 7.25877V3.33283C14.4997 3.09483 14.3317 2.88876 14.0977 2.84276ZM13.4997 7.25877C13.4997 11.8354 9.22101 13.6989 7.99967 14.1369C6.77834 13.6989 2.49967 11.8348 2.49967 7.25877V3.74152C5.42301 3.13085 6.62494 2.5769 8.0096 1.89224C9.31294 2.54624 10.5523 3.12485 13.4997 3.74152V7.25877ZM8.67969 9.66616C8.67969 10.0342 8.38169 10.3328 8.01302 10.3328C7.64502 10.3328 7.34294 10.0342 7.34294 9.66616C7.34294 9.29816 7.63835 8.9995 8.00635 8.9995H8.01302C8.38102 8.9995 8.67969 9.29816 8.67969 9.66616ZM7.99967 5.16616C8.27567 5.16616 8.49967 5.39016 8.49967 5.66616V7.66616C8.49967 7.94216 8.27567 8.16616 7.99967 8.16616C7.72367 8.16616 7.49967 7.94216 7.49967 7.66616V5.66616C7.49967 5.39016 7.72367 5.16616 7.99967 5.16616Z"
      fill={color}
    />
  </svg>
);

export default IconShield1;
